import CloseIcon from '@mui/icons-material/Close';
import { Backdrop, Box, CircularProgress, IconButton, Modal, Typography } from '@mui/material';
import { message } from 'antd';
import axios from 'axios';
import { useContext, useState } from 'react';
import { configUrl } from '../../config';
import { LoginContext } from '../../contexts/LoginContext';
import verifyPayment from '../../Hooks/verifyPayment';
import getPrivilegeService from '../../services/getPrivilegeService';
import CheckoutPage from '../CheckoutPage';

const MedineerLogin = ({ course, ResourceTypeId, onProceedToPayment, existingUserEmail, userTypeId, closeModal, isFreeSubscription }) => {

    const { providerId, UserId, emailC, userDetail, setUserPrivileges } = useContext(LoginContext);
    const [showModal, setShowModal] = useState(true); // Modal opens by default
    const [loading, setLoading] = useState(false);
    const razorpay_key = configUrl.razorPayKey;

    console.log("coursedata", course, UserId, userDetail);
    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    const createOrder = async (amount) => {
        try {
            const response = await axios.post(`${configUrl.AssessmentServer}/api/Payments/createOrder/${amount}`);
            return response.data.orderId;
        } catch (error) {
            console.error("Error creating order:", error);
            //return null;
        }
    };


    const initiatePayment = async (couponData) => {
        const couponId = couponData?.price, discountedPrice = couponData?.finalPrice;
        const isScriptLoaded = await loadRazorpayScript();
        if (!isScriptLoaded) {
            alert("Failed to load.Please check your connection");
            return;
        }

        const amount = discountedPrice || 0; // Example amount, replace with actual value
        const orderId = await createOrder(discountedPrice || 0);

        if (!orderId) {
            alert("Failed to create order. Please try again.");
            return;
        }

        const options = {
            key: razorpay_key,
            amount: amount * 100,
            currency: "INR",
            name: "Splayndid",
            description: "Course Purchase",
            order_id: orderId,
            handler: async (res) => { await verify(res, couponId, discountedPrice); },
            prefill: {
                name: userDetail?.fullName,
                email: emailC,
                contact: userDetail?.mobile, // Customer's phone number
            },
            theme: {
                color: "#3399cc",
            },

            config: {
                display: {
                    hide: [
                        { method: "card" },
                        { method: "netbanking" },
                        { method: "wallet" },
                        { method: "emi" },
                        { method: "paylater" }
                    ]
                }
            }
        };


        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
    };
    const setPrivileges = async () => {
        const privilegesDetails = await getPrivilegeService.getPrivileges(UserId);
        setUserPrivileges(privilegesDetails);
    };
    const verifyFreeSubscription = async () => {
        setLoading(true);
        let valid = false;
        const paymentData = {
            razorpayOrderId: "",
            razorpayPaymentId: "",
            razorpaySignature: "",
        };
        const finalAmount = course?.price;
        const paymentInfo = {
            providerId: providerId,
            ResourceId: course?.courseId,
            ResourceTypeId: 4,   // will decide trough navigation BSS@121 4,3,2,0
            price: finalAmount || 0,//100, //price;,
            paymentMethod: null,
            couponCodeId: null
        }

        const medineerUserId = existingUserEmail ? 0 : UserId?.length > 0 ? UserId[0] : UserId;
        const studentInfo = { userId: medineerUserId, userTypeId: userTypeId ?? userDetail?.userTypeId, email: existingUserEmail }
        const educationInfo = { userId: 0 };
        let request = {};
        request.studetnInfo = studentInfo //userDto;
        request.paymentVerification = paymentData;
        request.paymentInfo = paymentInfo;
        request.educationInfo = educationInfo;
        try {
            const verificationResponse = await verifyPayment(request);

            console.log("response", verificationResponse);
            if (verificationResponse?.data && verificationResponse.data?.message) {
                setTimeout(() => {
                    message.success(`Subscription assigned successfully.`);
                }, 1500);
            } else {
                message.error("Failed to assigned subscription.");
            }
        } catch (error) {
            console.log("error", error);
            message.error("Failed to assigned subscription.");
        } finally {
            console.log("in finally");
            setLoading(false);
        }
    }

    const verify = async (response, couponId, discountedPrice) => {
        setLoading(true);
        console.log("coupdadat", couponId);
        console.log("paymentreponse", response);
        const paymentData = {
            razorpayOrderId: response.razorpay_order_id,
            razorpayPaymentId: response.razorpay_payment_id,
            razorpaySignature: response.razorpay_signature,
        };
        const finalAmount = discountedPrice == null ? course?.price : discountedPrice;
        const paymentInfo = {
            providerId: providerId,
            ResourceId: course?.courseId,  //courseId;,
            ResourceTypeId: ResourceTypeId ?? 3,
            price: finalAmount || 0,//100, //price;,
            paymentMethod: null,
            couponCodeId: couponId
        }
        console.log("userdata", UserId, existingUserEmail);
        const medineerUserId = existingUserEmail ? 0 : UserId?.length > 0 ? UserId[0] : UserId;
        const studentInfo = { userId: medineerUserId, userTypeId: userTypeId ?? userDetail?.userTypeId, email: existingUserEmail }
        const educationInfo = { userId: 0 };
        let request = {};
        request.studetnInfo = studentInfo //userDto;
        request.paymentVerification = paymentData;
        request.paymentInfo = paymentInfo;
        request.educationInfo = educationInfo;

        console.log("data", request);
        // handleCloseModal();                          // temporary added while  payment page is not in used. 
        try {
            const verificationResponse = await verifyPayment(request);

            console.log("response", verificationResponse);
            if (verificationResponse?.data && verificationResponse.data?.message) {
                if (userDetail?.userTypeId === 12) {
                    setPrivileges()
                }
                setTimeout(() => {
                    message.success({ content: `${(ResourceTypeId && ResourceTypeId == 4) ? "Payment successful." : "Payment successful.You will get course assign within next 1 hour."}`, duration: 7 });
                }, 1500);
            } else {
                message.error("Failed to register and create order.");
            }
        } catch (error) {
            console.log("error", error);
            message.error("Failed to register and create order.");
        } finally {
            console.log("in finally");
            setLoading(false);
            handleCloseModal();
        }
    }
    const handleCloseModal = () => {
        closeModal();
        setShowModal(false);
    };

    return (
        <>
            <Backdrop
                open={loading}
                sx={{
                    color: '#fff',
                    zIndex: (theme) => theme.zIndex.modal + 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <CircularProgress size={60} />
                <Typography variant="h6" sx={{ mt: 2 }}>
                    Processing your request, please wait...
                </Typography>
            </Backdrop>
            <Modal
                open={showModal}
                onClose={handleCloseModal}
                aria-labelledby="checkout-modal-title"
                aria-describedby="checkout-modal-description"
                disableEnforceFocus
                disableScrollLock
                BackdropProps={{
                    style: { backgroundColor: 'transparent' },
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90%',
                        maxWidth: '600px',
                        bgcolor: 'background.paper',
                        p: 4,
                        borderRadius: 2,
                        boxShadow: 'none',
                        border: '1px solid rgba(0, 0, 0, 0.1)',
                        position: 'relative',
                    }}
                >
                    {/* Close Button */}
                    <IconButton
                        onClick={handleCloseModal}
                        sx={{
                            position: 'absolute !important',
                            top: '8px !important',
                            right: '8px !important',
                            zIndex: 10,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    <Typography
                        id="checkout-modal-title"
                        variant="h4"
                        align="center"
                        gutterBottom
                    >
                        Checkout
                    </Typography>
                    <CheckoutPage
                        course={course}
                        isFreeSubscription={isFreeSubscription && isFreeSubscription == true ? true : false}
                        onProceedToPayment={(couponData) => {
                            console.log("coupdfirst", couponData);
                            if (isFreeSubscription && isFreeSubscription == true) {
                                verifyFreeSubscription();
                                handleCloseModal();
                            } else {
                                initiatePayment(couponData);
                                handleCloseModal();
                            }

                        }}
                    />
                </Box>
            </Modal>
        </>
    );
};

export default MedineerLogin;
